<template>
<div>
    <div v-if="isShare" class="cc-new-share">
        <div class="cc-new-share__item" @click.stop.prevent="onShare">
            <div class="cc-new-share__item__icon"/>
        </div>
    </div>
    <div
            v-else-if="services"
            ref="yaShare2"
            :data-lang="lang"
            :data-services="services"
            class="ya-share2"
            data-color-scheme="whiteblack"
            data-curtain
            data-limit="0"
            data-more-button-type="short"
            data-shape="round"
    />
    <div v-else class="cc-new-share">
        <div class="cc-new-share__item" @click.stop.prevent="onClick">
            <div class="cc-new-share__item__icon"/>
        </div>
        <div class="cc-new-share__menu" :class="{'is-open': open}">
            <a class="cc-new-share__menu__item" target="_blank" :href="links.facebook">
                <span class="cc-new-share__menu__item__icon is-facebook"/>
                <span>Facebook</span>
            </a>
            <a class="cc-new-share__menu__item" target="_blank" :href="links.telegram">
                <span class="cc-new-share__menu__item__icon is-telegram"/>
                <span>Telegram</span>
            </a>
            <a class="cc-new-share__menu__item" target="_blank" :href="links.twitter">
                <span class="cc-new-share__menu__item__icon is-twitter"/>
                <span>Twitter</span>
            </a>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Share2',
  props: {
    title: String,
    image: String,
    description: String
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    isShare () {
      return 'share' in navigator && /iPhone|iPad|iPod|Android|mobile/i.test(navigator.userAgent)
    },
    links () {
      const link = encodeURIComponent(location.href)
      return {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${link}`,
        instagram: `https://www.instagram.com/p/${link}/`,
        telegram: `https://t.me/share/url?url=${link}`,
        twitter: `https://twitter.com/intent/tweet?text=${link}`,
      }
    },
    lang () {
      const lang = document.querySelector('html').getAttribute('lang')
      return [
        'az',
        'be',
        'hy',
        'ka',
        'kk',
        'ro',
        'ru',
        'tr',
        'tt',
        'uk',
        'uz'
      ].indexOf(lang) !== -1 ? lang : 'en'
    },
    services () {
      const lang = document.querySelector('html').getAttribute('data-location')

      if (lang === 'RU') {
        return 'messenger,vkontakte,odnoklassniki,telegram'
      } else if ([
        'BY',
        'KZ',
        'AM'
      ].indexOf(lang) !== -1) {
        return 'messenger,vkontakte,odnoklassniki,telegram,twitter'
      } else {
        return undefined
      }
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.services) {
        window.Ya.share2(this.$refs.yaShare2, {
          content: {
            url: window.location.href,
            title: this.title,
            image: this.image,
            description: this.description
          }
        })
      }
    }, 400)
  },
  methods: {
    onClick () {
      this.open = !this.open

      if (this.open) {
        requestAnimationFrame(() => {
          document.body.addEventListener('click', () => {
            requestAnimationFrame(() => this.open = false)
          }, { once: true })
        })
      }
    },
    async onShare () {
      try {
        await navigator.share({
          title: document.title,
          text: document.description,
          url: location.pathname
        })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="css">
.cc-new-share {
    --new-share-size: 20px;
    position: relative;
}

.cc-new-share__item {
    padding: 4px;

    border-radius: var(--new-share-size);
    cursor: pointer;
}

.cc-new-share__item:hover {
    background-color: rgba(37, 38, 49, .04);
}

.cc-new-share__item__icon {
    width: var(--new-share-size);
    height: var(--new-share-size);

    background-image: url("../assets/img/baseline_share_black_24dp.png");
    background-position: center;
    background-size: cover;
}

.cc-new-share__menu {
    display: none;
    position: absolute;
    right: 0;
    top: calc(var(--new-share-size) + 8px);
    overflow: hidden;

    font-size: 14px;
    line-height: 20px;

    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.cc-new-share__menu.is-open {
    display: block;
}

.cc-new-share__menu__item {
    display: flex;
    align-items: center;
    justify-items: center;

    padding: 4px 16px;
    width: 100%;

    cursor: pointer;
}

.cc-new-share__menu__item:hover {
    color: white !important;
    background-color: #FA5F55;
}

.cc-new-share__menu__item__icon {
    width: 20px;
    height: 20px;
    margin-right: 16px;

    background-color: rgb(37, 38, 49);
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
}

.cc-new-share__menu__item:hover .cc-new-share__menu__item__icon {
    background-color: white;
}

.cc-new-share__menu__item__icon.is-facebook {
    -webkit-mask-image: url("../assets/img/iconmonstr-facebook-1.svg");
    mask-image: url("../assets/img/iconmonstr-facebook-1.svg");
}

.cc-new-share__menu__item__icon.is-instagram {
    -webkit-mask-image: url("../assets/img/iconmonstr-instagram-11.svg");
    mask-image: url("../assets/img/iconmonstr-instagram-11.svg");
}

.cc-new-share__menu__item__icon.is-telegram {
    -webkit-mask-image: url("../assets/img/iconmonstr-telegram-1.svg");
    mask-image: url("../assets/img/iconmonstr-telegram-1.svg");
}

.cc-new-share__menu__item__icon.is-twitter {
    -webkit-mask-image: url("../assets/img/iconmonstr-twitter-1.svg");
    mask-image: url("../assets/img/iconmonstr-twitter-1.svg");
}
</style>
